import { Component, Input, Output, OnInit, OnChanges, SimpleChanges, EventEmitter } from '@angular/core';
import { Round } from 'src/app/models/ReceivedPoll';

@Component({
  selector: 'app-assessors-result',
  templateUrl: 'assessors-result.component.html',
  styleUrls: ['./assessors-result.component.less', '../../../shared/common.less'],
})

export class AssessorsResultComponent implements OnInit, OnChanges {
  @Input() isValidated: boolean = false;
  @Output() displayResultEvent = new EventEmitter();
  @Input() rounds: Array<Round> = [];

  groupedRounds: { college: number; rounds: Round[] }[] = [];
  expandedColleges = new Set<number>();
  // roundId -> tableau de pourcentages par liste
  votePercentages = new Map<number, number[]>();
  // roundId -> premier tableau de votes
  firstTestResults = new Map<number, number[]>();

  isExpanded(college: number): boolean {
    return this.expandedColleges.has(college);
  }

  toggleCollege(college: number): void {
    if (this.expandedColleges.has(college)) {
      this.expandedColleges.delete(college);
    } else {
      this.expandedColleges.add(college);
    }
  }

  roundsByCollege(): { college: number; rounds: Round[] }[] {
    const map = new Map<number, Round[]>();
    for (const round of this.rounds) {
      const group = map.get(round.college) ?? [];
      group.push(round);
      map.set(round.college, group);
    }
    return Array.from(map.entries()).map(([college, rounds]) => ({ college, rounds }));
  }

  private computeVotePercentages(): void {
    this.votePercentages = new Map();
    this.firstTestResults = new Map();
    for (const round of this.rounds) {
      if (!round.testResults) continue;
      try {
        const parsed: number[][] = JSON.parse(round.testResults);
        const votes = Array.isArray(parsed) && parsed.length > 0 ? parsed[0] : [];
        this.firstTestResults.set(round.round, votes);
        const total = votes.reduce((sum, v) => sum + v, 0);
        const percentages = votes.map(v => total === 0 ? 0 : (v / total) * 100);
        this.votePercentages.set(round.round, percentages);
      } catch {}
    }
  }

  getVotePercentage(roundId: number, index: number): number {
    const value = this.votePercentages.get(roundId)?.[index] ?? 0;
    return Math.round(value * 10) / 10;
  }

  getFirstTestResult(roundId: number, index: number): number {
    return this.firstTestResults.get(roundId)?.[index] ?? 0;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['rounds']) {
      this.groupedRounds = this.roundsByCollege();
      if (this.groupedRounds.length > 0) {
        this.expandedColleges = new Set([this.groupedRounds[0].college]);
      }
      this.computeVotePercentages();
    }
  }

  ngOnInit(): void {
    this.groupedRounds = this.roundsByCollege();
    if (this.groupedRounds.length > 0) {
      this.expandedColleges = new Set([this.groupedRounds[0].college]);
    }
    this.computeVotePercentages();
  }
}
